import React from 'react';
import moment from 'moment';
import type { NativeDateTimeInputProps } from '@hexia/survey-client-native';
import UnifiedDateTimePicker from '../UnifiedDateTimePicker';

export const parseSurveyDateTimeBound = (mode: 'date' | 'time', value?: string): Date | undefined => {
  if (!value) return undefined;
  // SurveyJS date/time answers are local strings, not UTC instants.
  const parsed = moment(value, mode === 'date' ? 'YYYY-MM-DD' : 'HH:mm', true);
  return parsed.isValid() ? parsed.toDate() : undefined;
};

export const SurveyDateTimeInput = (props: NativeDateTimeInputProps) => <UnifiedDateTimePicker
  mode={props.mode}
  value={props.value}
  onChange={props.onChange}
  disabled={props.disabled}
  accessibilityLabel={props.label}
  placeholder={props.placeholder}
  minDate={parseSurveyDateTimeBound(props.mode, props.minimum)}
  maxDate={parseSurveyDateTimeBound(props.mode, props.maximum)}
  fieldStyle={{ minHeight: 50, borderRadius: 10 }}
/>;
